import styled, { css } from 'styled-components';

export const BlackBackGroundTemp = styled.div`
    width: 100%;
    height: 100vh;
    top: 0;
    left: 0;
    z-index: 1100;
    background-color: rgba(0, 0, 0, 0.8);
    position: fixed;
`;

export const flexCenter = css`
    display: flex;
    justify-content: center;
    align-items: center;
`;
